// extracted by mini-css-extract-plugin
export var category = "FaqAnswerList-module--category--aa4b3";
export var categoryTitle = "FaqAnswerList-module--categoryTitle--31be6";
export var question = "FaqAnswerList-module--question--e0a60";
export var svg = "FaqAnswerList-module--svg--2b353";